import React from 'react';
import { HomeDashboard } from './HomeDashboard';

export const HomeCard = () => {
  return (
    <>
      <HomeDashboard />
    </>
  );
};